import { Box, Grid, styled, Chip } from '@mui/material';
import { IDncLog } from 'wisestep-api';
import {
  timeSince,
  WsColors,
  WsDotColors,
  WsDotIcon,
  WsDotTextColors,
  WsFilePreview,
  WsTypography,
} from 'wisestep-base';

import { getFile } from '../../../features/careerPageSettings/util';
import { downloadCV } from '../utils/cvHelper';

interface DNCLogsProps {
  logs: IDncLog[];
}

type ChipType = {
  textColor: string;
  bgColor?: string;
  fontWeight?: number;
  mt?: string;
};

const StyledChip = styled(Chip)(
  ({ textColor, bgColor = WsColors.TheBlues500, fontWeight = 800, mt = '0px' }: ChipType) => ({
    color: textColor,
    borderRadius: 4,
    fontSize: '14px',
    marginRight: 5,
    marginTop: mt,
    background: bgColor,
    fontWeight: fontWeight,
  })
);
const StyledBox = styled(Box)(() => ({
  marginLeft: 32,
  marginTop: 8,
}));

const onViewClick = async (url: string): Promise<string> => await getFile(url.split('?')[0]);

const DNCLogs = ({ logs }: DNCLogsProps) => (
  <>
    {logs.map((log, index) => (
      <StyledBox key={index} sx={{ border: 1, borderColor: WsColors.BorderGrey, borderRadius: 2 }}>
        <Grid container m={1}>
          <Grid item m={0.5} xs={5}>
            <StyledChip
              label={(log.dataPrivacyOption ?? 'OPEN').toUpperCase()}
              size="small"
              textColor={WsColors.TertiaryShades800}
              bgColor={WsColors.TheBlues300}
              fontWeight={500}
            />
          </Grid>
          <Grid item m={0.5} xs={6} display="flex" justifyContent="flex-end">
            <WsTypography> View Attachment :</WsTypography>{' '}
            <WsFilePreview
              url={log.attachmentUrl ?? ''}
              onViewClick={() => onViewClick(log.attachmentUrl ?? '')}
              onDownload={() => downloadCV(log.attachmentUrl ?? '')}
            />
          </Grid>
          <Grid item xs={12} m={0.5}>
            <WsDotIcon
              color={WsDotColors.SENARY}
              textColor={WsDotTextColors.SENARY}
              value={`Comment : ${log.notes ?? log.comment}`}
            />
          </Grid>
          <Grid item xs={12} m={0.5}>
            <WsDotIcon
              color={WsDotColors.SENARY}
              textColor={WsDotTextColors.SENARY}
              value={`Data Privacy Option changed By : ${log.recruiterEmail} ${timeSince(
                String(log.createdOn?.toString())
              )}`}
            />
          </Grid>
        </Grid>
      </StyledBox>
    ))}
  </>
);

export default DNCLogs;
